<script>
	import { Route } from "tinro";
	import Transition from "./components/Transition.svelte";

	import ContentCategory from "./pages/contents/CategoryContents.svelte";
	import ContentCategoryGen2 from "./pages/contents/CategoryContentsGen2.svelte";
	import ContentNotices from "./pages/contents/Notice.svelte";
	import ContentMusicsSleeps from "./pages/contents/MusicSleeps.svelte";
	import ContentMeditationMusics from "./pages/contents/MeditationMusics.svelte";
	import ContentMusicFocus from "./pages/contents/FocusMusics.svelte";
	import ContentSoundSignals from "./pages/contents/SoundSignals.svelte";
	import ContentSoundSources from "./pages/contents/SoundSources.svelte";
	import ContentSoundMusics from "./pages/contents/SoundMusics.svelte";
	import ContentSoundMusicsGen2 from "./pages/contents/SoundMusicsGen2.svelte";
	import ContentSoundImagesGen2 from "./pages/contents/SoundImagesGen2.svelte";
	import ContentAiReportPrompt from "./pages/contents/AiReportPrompt.svelte";
	import VersionApp from "./pages/version/App.svelte";
	import VersionAlgorithm from "./pages/version/Algorithm.svelte";
	import VersionFirmware from "./pages/version/Firmware.svelte";
	import VersionFirmwareGen2 from "./pages/version/FirmwareGen2.svelte";
	import Dashboard from "./pages/Dashboard.svelte";
	import DeviceDistribution from "./pages/device/Distribution.svelte";
	import DeviceManagement from "./pages/device/Management.svelte";
	import UserManagement from "./pages/user/Management.svelte";
	import AdminManagement from "./pages/admin/Management.svelte";
    import LogApi from "./pages/log/LogApi.svelte";
    import LogApp from "./pages/log/LogApp.svelte";
    import Test from "./pages/email/MailSendTest.svelte";
    import MailSendTest from "./pages/email/MailSendTest.svelte";

	const routes = [
		{
			path: "/contents/category/contents",
			component: ContentCategory,
		},
		{
			path: "/contents/category/contents/gen2",
			component: ContentCategoryGen2,
		},
		{
			path: "/contents/notices",
			component: ContentNotices,
		},
		{
			path: "/contents/musics/sleeps",
			component: ContentMusicsSleeps,
		},
		{
			path: "/contents/musics/meditations",
			component: ContentMeditationMusics,
		},
		{
			path: "/contents/musics/focus",
			component: ContentMusicFocus,
		},
		{
			path: "/contents/sound/signals",
			component: ContentSoundSignals,
		},
		{
			path: "/contents/sound/sources",
			component: ContentSoundSources,
		},
		{
			path: "/contents/sound/musics",
			component: ContentSoundMusics,
		},
		{
			path: "/contents/sound/musics/gen2",
			component: ContentSoundMusicsGen2,
		},
		{
			path: "/contents/sound/images/gen2",
			component: ContentSoundImagesGen2,
		},
		{
			path: "/contents/ai-report-prompt",
			component: ContentAiReportPrompt,
		},
		{
			path: "/version/app",
			component: VersionApp,
		},
		{
			path: "/version/algorithm",
			component: VersionAlgorithm,
		},
		{
			path: "/version/firmware",
			component: VersionFirmware,
		},
		{
			path: "/version/firmware/gen2",
			component: VersionFirmwareGen2,
		},
		{
			path: "/dashboard",
			component: Dashboard,
		},
		{
			path: "/device/distribution",
			component: DeviceDistribution,
		},
		{
			path: "/device/management",
			component: DeviceManagement,
		},
		{
			path: "/user/management",
			component: UserManagement,
		},
		{
			path: "/admin/management",
			component: AdminManagement,
		},
		{
			path: "/log/api",
			component: LogApi,
		},
		{
			path: "/log/app",
			component: LogApp,
		},
		{
			path: "/email/test",
			component: MailSendTest,
		},
	];

	// 메인 리다이렉트 경로
	const DEFAULT_ROUTE = "/dashboard";
</script>

<Transition>
	<!-- 메인 리다이렉트 -->
	<Route path="/" redirect={DEFAULT_ROUTE}>
		<ContentCategory />
	</Route>

	<!-- 정의된 라우트들 -->
	{#each routes as { path, component: Component }}
		<Route {path}>
			<Component />
		</Route>
	{/each}

	<!-- 404 페이지 -->
	<Route fallback>
		<div class="error-page">
			<h1>페이지를 찾을 수 없습니다</h1>
			<a href={DEFAULT_ROUTE}>메인으로 돌아가기</a>
		</div>
	</Route>
</Transition>

<style>
	.error-page {
		text-align: center;
		padding: 2rem;
	}
	.error-page a {
		color: #0d6efd;
		text-decoration: none;
	}
</style>
